import { forwardRef } from 'react';
import { AppBar as MuiAppBar, AppBarProps as MuiAppBarProps } from '@mui/material';

export type AppBarProps = MuiAppBarProps;

/**
 * AppBar component - Top-of-screen application bar.
 *
 * Thin wrapper around MUI AppBar that gives the design system a single
 * styling/behavior hook for global headers. Pair with `Toolbar` for the
 * standard horizontal layout.
 *
 * @example
 * <AppBar position="static" elevation={0}>
 *   <Toolbar>...</Toolbar>
 * </AppBar>
 */
export const AppBar = forwardRef<HTMLElement, AppBarProps>((props, ref) => (
  <MuiAppBar ref={ref} {...props} />
));

AppBar.displayName = 'AppBar';
